import React from 'react';
import { connect } from 'react-redux';
import CharChooseBtn from '../shared/CharChooseBtn';
import CharSpaceBtn from '../shared/CharSpaceBtn';
import { charCase, charSelected } from '../../../actions/char';
import { genCharArray } from '../../../utils/utils';

export class OwnChoose extends React.Component {
	constructor(props) {
	    super(props);

	    this.state = {
	    	array: [],
	    	charType: 'lc'
	    };
  	}
    onClick = (e) => {
    	this.props.charSelected(e.target.id);
	}
	setCharType = (charCase) => {
		let charArray;

		if (charCase === 'uc') {
			charArray = genCharArray('a', 'z', true);
		} else {
			charArray = genCharArray('a', 'z');
		}

		this.setState({
			charType: charCase,
			array: charArray
		 });
	}
	switchCase = (e) => {
		let caseType;
		if (e.target.id === 'lowercase-btn') {
			caseType = 'lc';
		} else {
			caseType = 'uc';
		}
		this.setCharType(caseType);
		this.props.charCase(caseType);
	}
	componentDidMount() {
		this.setCharType('lc');
	}
	componentWillUnmount() {
		this.props.charSelected(undefined);
		this.props.charCase('lc');
	}
    render() {
        return (
            <div id="own-choose" className="char-choose panel">
		        <div className="title"></div>
		        <div className="panel-arrow-r"></div>
		        <div className="holder">
		            <div className="holder-inner">
		            	{this.state.array.map((label, index) => {
		                    return (
		                        <CharChooseBtn charType={this.state.charType} selected={false} key={index} label={label} onClick={this.onClick} />
		                    );
		                })}
		                <CharSpaceBtn charType={this.state.charType} key={26} selected={false} label="space" onClick={this.onClick} />
		            </div>
		        </div>
		        <div id="lowercase-btn" className={this.state.charType === 'lc' ? "case-btn is-active" : "case-btn"} onClick={this.switchCase}></div>
		        <div id="uppercase-btn" className={this.state.charType === 'uc' ? "case-btn is-active" : "case-btn"} onClick={this.switchCase}></div>
		    </div>
        );
    }
};

const mapStateToProps = (state) => ({
	char: state.char.char
})

const mapDispatchToProps = (dispatch) => ({
	charSelected: (char) => dispatch(charSelected(char)),
	charCase: (char) => dispatch(charCase(char))
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnChoose);



// WEBPACK FOOTER //
// ./src/components/sections/own/OwnChoose.js